



































import { Component, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RewardsDisclaimer from '@/components/molecules/RewardsDisclaimer/RewardsDisclaimer.vue';

import SignUpService from '@/api/SingupService';
import { IBusinessType } from '@/models/business';

import { EOnlineInStoreStepSlug } from '../OnlineInStoreModal.vue';

@Component({
  components: {
    FilledButton,
    RewardsDisclaimer
  }
})
export default class Confirmation extends Vue {
  signUpService = new SignUpService();

  loading = false;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  async onStart() {
    this.loading = true;
    try {
      await this.signUpService.setupRules({
        operationType: IBusinessType.BOTH
      });

      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.businessInfo,
        operationType: IBusinessType.BOTH
      });

      this.$emit('goToStep', {
        redirectToSlug: EOnlineInStoreStepSlug.FEEDBACK_STATUS
      });
    } finally {
      this.loading = false;
    }
  }
}
